export const apiName: string = 'contas-contabeis';
export const contasContabeisRouter: string = 'contas-contabeis';
export const contasContabeisStorage: string = 'contascontabeis';
export const contasContabeisModuleName: any = {plural: 'Contas contábeis', single: 'Conta contábil'};

export const modelosContaContabil: any[] = [
    { Key: 1, Value: 'Sintético' },
    { Key: 2, Value: 'Analítico' }
];

export const contaContabilCodigoMask: number = 15; //9 digitos + 6 pontos

export const contasContabeisQuery: any = {
    "where":{
        "ativo":true,
        "descricao":{"regexp":"/REPLACEHERE/i"}
    },
    "order":"descricao"
};//include:["contaContabil"]



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/contas/conta-contabil/shared/data.service.ts
 **/